/**
 * Wiring debug API client
 *
 * Fetches the full wiring breakdown for a single artifact — blueprint,
 * registry entries, resolved card/detail slots, and action visibility.
 */

import { z } from 'zod';
import { apiLogger } from '../lib/logger';
import { fetchJson, type ApiFetch } from '../lib/apiFetchJson';
import { WiringActionDataSchema, WiringDataSchema } from './wiring.schema';

export type WiringActionData = z.infer<typeof WiringActionDataSchema>;
export type WiringData = z.infer<typeof WiringDataSchema>;

/**
 * Fetch the full wiring breakdown for a single artifact. A non-2xx answer is a
 * `problem()` body (`src/api/v4/artifacts.ts`), thrown as an `ApiProblemError`
 * whose `status` and `code` are the route's and whose `message` is its
 * `detail`, else its `title`.
 */
export async function fetchWiring(apiFetch: ApiFetch, artifactId: string): Promise<WiringData> {
  apiLogger.debug({ artifactId }, 'fetchWiring');
  return fetchJson(apiFetch, WiringDataSchema, `/api/v4/artifacts/${encodeURIComponent(artifactId)}/wiring`);
}
